import { useState } from "react";
import "./Tabs.css"; // Import the CSS file
import { GoArrowRight } from "react-icons/go";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { Link } from "react-router-dom";

const Tabs = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="tabs-container">
      <div className="tabs-btn-container">
      <div className="tabs">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab-button ${activeTab === index ? "active" : ""}`}
            onClick={() => setActiveTab(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      </div>
      <div className="tab-content">
        <p className="tab-description">        {tabs[activeTab]?.content}
        </p>
        <ul className="tab-lists">
            {tabs[activeTab]?.lists.map((list,index)=> {
                return <Link to={`/schedule-interview`} className="tab-list">
                  <li key={index}>{list}</li>
                  <HiOutlineArrowNarrowRight className="tab-icon"/>
                </Link>
            })}
        </ul>
      </div>
    </div>
  );
};

export default Tabs;
